<template>
  <div id='home'>
    <div v-if="isAuthenticated">
      You are logged in as<br/><br/><b>{{ loginDisplay }}</b>
    </div>
    <div v-else>
      You are not logged in.
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Home',
  components: {
  },
  computed: {
    loginDisplay () {
      if( this.user.myDisplayName ) return this.user.myDisplayName
      return this.user.email
    },
    ...mapState({
      isAuthenticated: state => state.authentication.isAuthenticated,
      user: state => state.authentication.user,
      guilds: state => state.guilds.guilds,
    }),
  },
}
</script>

<style scoped>
#home {
  padding: 30px;
}
</style>